import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CategoryRowItem from './CategoryRowItem';

function classNames(...classes) {
	return classes.filter(Boolean).join(' ');
}

const CategoryRow = ({ category, categories, sortId }) => {
	let navigate = useNavigate();
	const { setNodeRef, attributes, listeners, transform, transition } = useSortable({
		id: sortId,
	});
	const [title, setTitle] = useState(null);
	const [enabled, setEnabled] = useState(category.enabled);
	const [parentTitle, setParentTitle] = useState(category.parentTitle);
	const [localCategory, setLocalCategory] = useState(category);

	useEffect(() => {
		setTitle(localCategory.title);
		setEnabled(localCategory.enabled);
		setParentTitle(localCategory.parentTitle);
	}, [localCategory]);

	function handleEditClick(id) {
		navigate('edit/' + id);
	}

	const style = {
		transition,
		transform: CSS.Transform.toString(transform),
	};

	return (
		<CategoryRowItem
			attributes={attributes}
			category={category}
			title={title}
			enabled={enabled}
			localCategory={localCategory}
			parentTitle={parentTitle}
			listeners={listeners}
			nodeRef={setNodeRef}
			transition={transition}
			transform={transform}
			handleClick={handleEditClick}
		/>
	);
};

export default CategoryRow;
